import { render, staticRenderFns } from "./spaceTemplateTable.vue?vue&type=template&id=59e59702&scoped=true&"
import script from "./spaceTemplateTable.vue?vue&type=script&lang=ts&"
export * from "./spaceTemplateTable.vue?vue&type=script&lang=ts&"
import style0 from "./spaceTemplateTable.vue?vue&type=style&index=0&id=59e59702&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e59702",
  null
  
)

export default component.exports